// extracted by mini-css-extract-plugin
export var fadeIn = "_bf-0";
export var panelInner = "_bf-2";
export var panelOuter = "_bf-1";